import types from './mutations-types';
import api from './api';

export default {
	async getPlants_({ commit }) {
		let data = await api.getPlants();
		let options = [];

		if (data.header.code === 0) {
			if (data.body) {
				data.body.map(v => {
					if (v.commCdName !== 'PLANT') {
						options.push({ text: v.commCdName, value: v.commCd });
					}
				});
			}

			commit(types.DEFAULT_ASSIGN, {
				key: 'plants',
				value: options
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		}

		return data.header;
	},
	async getLogTypes_({ commit }, { plantCd, commCdType }) {
		let data = await api.getLogTypes({ plantCd, commCdType });
		let options = [];

		if (data.header.code === 0) {
			if (data.body) {
				options.push({ text: 'All', value: '' });
				data.body.map(v => {
					if (v.commCd != 'B' && v.commCd != 'U') {
						options.push({ text: `${v.commCd} ${v.commCdName}`, value: v.commCd });
					}
				});
			}
			commit(types.DEFAULT_ASSIGN, {
				key: 'logTypes',
				value: options
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	},
	async getErrorLogList_({ commit }, { searchParams, currentPage, pageUnit }) {
		let store = this.state.errorLogStore;
		let data = await api.getErrorLogList({ searchParams, currentPage, pageUnit });

		if (data.header.code === 0) {
			let body = data.body.resultList;

			body.map((object, index) => {
				object.test = index;
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: body
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'groups',
				value: data.body.pagingInfo
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	},
	setConfirm_({ commit, dispatch }, { plantCd, payload }) {
		return api
			.setConfirm({ plantCd, payload })
			.then(header => {
				//dispatch('getProcesses');
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	//
	async getDependencies_({ commit, state }, { currentPage, pageUnit }) {
		let data = await api.getDependencies({
			...state.searchParams,
			currentPage,
			pageUnit
		});

		if (data.header.code === 0) {
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: data.body.resultList
			});
			// console.log('data.body.pagingInfo', data.body.pagingInfo);
			commit(types.DEFAULT_ASSIGN, {
				key: 'pagingInfo',
				value: data.body.pagingInfo
			});
			// console.log('state.pagingInfo', state.pagingInfo);
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	},
	async getCommonCodes_({ commit, state }) {
		let data = await api.getCommonCodes({
			...state.searchParams
		});

		if (data.header.code === 0) {
			commit(types.SET_OPTION_LIST, {
				key: 'branches',
				list: data.body.branches
			});
			commit(types.SET_OPTION_LIST, {
				key: 'services',
				list: data.body.services
			});
			commit(types.SET_OPTION_LIST, {
				key: 'langs',
				list: data.body.langs
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SET_SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	}
};
